export interface VerifiedAddress {
  city: string;
  countryCode: string;
  primaryLine: string;
  secondaryLine: string;
  state: string;
  usCountryCode: boolean;
  zip: string;
  zipPlus4: string | null;
  fffUndeliverable: boolean;
  lobUndeliverable: boolean;
}

export interface AddressVerificationResponse {
  readyToSubmit: boolean;
  message: string | undefined;
  modalType: string | undefined;
  deliveryStatus: string;
  errorMessage: string | null;
  submitted: VerifiedAddress;
  verified: VerifiedAddress;
}

export function emptyVerifiedAddress(): VerifiedAddress {
  return {
    city: '',
    countryCode: '',
    primaryLine: '',
    secondaryLine: '',
    state: '',
    usCountryCode: false,
    zip: '',
    zipPlus4: '',
    fffUndeliverable: false,
    lobUndeliverable: false,
  };
}

export function emptyAddressVerificationResponse(): AddressVerificationResponse {
  return {
    deliveryStatus: '',
    errorMessage: null,
    submitted: emptyVerifiedAddress(),
    verified: emptyVerifiedAddress(),
    message: undefined,
    modalType: undefined,
    readyToSubmit: false,
  };
}
